import { lazyLoadingData } from '../../functions';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { settingsData, threeJsVariables } from '../../settings';
import { Box3, Color, DoubleSide, Mesh, MeshBasicMaterial, PlaneGeometry, TextureLoader, Vector3 } from 'three';
import gsap from 'gsap';
import {getCurrentLang} from "../language/langSwitcher";

export async function loadCylinderGrid () {
  const active = config.features.cylinderBase.active;
  const {cylinderBg} = config.resources.background;
  let path;

  if (!active){
    return;
  }

  const textureLoader = new TextureLoader();
  const languages = config.languages;

  settingsData.cylinderGridTextures = {};

  if (cylinderBg && cylinderBg === 'sky'){
    path = 'assets/model/cylinder/black';

  } else {
    path = 'assets/model/cylinder';
  }


  languages.forEach(lang => {
    settingsData.cylinderGridTextures[lang] = textureLoader.load(`${path}/base_${lang}.png`);
  });

  const geometry = new PlaneGeometry(200,200);
  const material = new MeshBasicMaterial({
    color: 0xffffff,
    map : settingsData.cylinderGridTextures[getCurrentLang()],
    side: DoubleSide,
    transparent: true,
    opacity: 0,
  });
  material.needsUpdate = true;
  material.visible = false;

  const {rotation,scale} = config.features.cylinderBase;

  const grid = new Mesh(geometry,material);
  grid.rotation.set(rotation.x,rotation.y,rotation.z);
  grid.scale.set(scale.x,scale.y,scale.z);
  grid.position.set(0,0,0);
  grid.name = "Cylinder Grids";

  threeJsVariables.scene.add(grid);
}

// export function showCylinderGrid (buildingIndex) {
//   const active = config.features.cylinderBase.active;
//   if (!active){
//     return;
//   }
//   // const grid = threeJsVariables.scene.getObjectByName(`cylinder_${buildingIndex}`);
//   const correction = config.features.cylinderBase.correctionPosY;
//   const grid = threeJsVariables.scene.getObjectByName('Cylinder Grids');
//   const activeBuilding = buildings_info.filter(building => building.isActive)[0];
//   const buildingOnScene = threeJsVariables.scene.getObjectByName(activeBuilding.name);
//   const center = new Box3().setFromObject(buildingOnScene).getCenter(new Vector3());
//   grid.position.set(center.x,buildingOnScene.position.y + correction,center.z);
//
//   if (grid){
//     gsap.to(grid.material,{
//       duration: .5,
//       opacity: 1,
//       onStart:()=>{
//         grid.material.visible = true;
//       }
//     })
//   }
// }

export function showCylinderGrid (building) {
  const active = config.features.cylinderBase.active;
  if (!active){
    return;
  }

  const correction = config.features.cylinderBase.correctionPosY;
  const grid = threeJsVariables.scene.getObjectByName('Cylinder Grids');
  const buildingOnScene = threeJsVariables.scene.getObjectByName(building.name);
  const center = new Box3().setFromObject(buildingOnScene).getCenter(new Vector3());
  grid.position.set(center.x,buildingOnScene.position.y + correction,center.z);

  if (grid){
    gsap.to(grid.material,{
      duration: .5,
      opacity: 1,
      onStart:()=>{
        grid.material.visible = true;
      }
    })
  }
}

// export function hideCylindersGrid () {
//   const active = config.features.cylinderBase.active;
//   if (!active){
//     return;
//   }
//   const grid = threeJsVariables.scene.getObjectByName('Cylinder Grids');
//   if (!grid){
//     return;
//   }
//
//   // const gridArray = gridGroup.children.filter(grid=> grid.visible);
//   // if (!gridArray.length){
//   //   return;
//   // }
//   //
//   // const activeGrid = gridArray[0];
//
//   const gridPromise = new Promise(resolve => {
//     gsap.to(grid.material,{
//       duration: .5,
//       opacity: 0,
//       onComplete: ()=>{
//         grid.material.visible = false;
//         resolve(true);
//       }
//     });
//
//   });
//
//   settingsData.animationsList.push(gridPromise);
//
// }


export function hideCylindersGrid () {
  const active = config.features.cylinderBase.active;
  if (!active){
    return;
  }
  const grid = threeJsVariables.scene.getObjectByName('Cylinder Grids');
  if (!grid){
    return;
  }

  return new Promise(resolve => {
    gsap.to(grid.material,{
      duration: .5,
      opacity: 0,
      onComplete: ()=>{
        grid.material.visible = false;
        resolve(true);
      }
    });
  });
}

export const changeGridTexture = async () => {
  const lang = getCurrentLang();

  const cylinderGrid = threeJsVariables.scene.getObjectByName('Cylinder Grids');
  cylinderGrid.material.map = settingsData.cylinderGridTextures[lang];
  cylinderGrid.material.needsUpdate = true;

  // console.log(lang);
  // console.log(settingsData.cylinderGridTextures[lang]);
  // console.log(cylinderGrid);
}
